// frontend/src/components/common/DataTable.js
export default function DataTable({ title, rows, columns }) {
  if (rows.length === 0) {
    return (
      <div className="my-2">
        <h3 className="text-base font-semibold text-neutral-900">{title}</h3>
        <p className="text-center text-neutral-500">데이터가 없습니다.</p>
      </div>
    );
  }

  // 공통 클래스
  const headClass =
    'px-2 py-1.5 border border-neutral-300 bg-neutral-100 whitespace-nowrap text-center text-lg font-semibold';

  const cellClass =
    'px-2 py-1.5 border border-neutral-300 bg-white whitespace-nowrap text-center text-lg';

  return (
    <div className="my-8 w-full min-w-0">
      <h2 className="mb-3 text-center text-lg font-semibold text-neutral-900">
        {title}
      </h2>

      {/* 테이블이 화면보다 넓으면 이 영역에서만 가로 스크롤 */}
      <div className="w-full overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.header}
                  className={headClass}
                  style={col.headerStyle}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((r) => (
              <tr key={r.id ?? JSON.stringify(r)}>
                {columns.map((col) => (
                  <td
                    key={col.header}
                    className={cellClass}
                    style={{
                      ...col.cellStyle,
                      background:
                        r.is_top && (r.n_peaks === 2)
                          ? '#fa6c530a'
                          : r.is_top && !(r.n_peaks === 2)
                            ? '#fa6c531f'
                            : !r.is_top && (r.n_peaks === 2)
                              ? '#81a9ff0a'
                              : '#81a9ff1f',
                    }}
                  >
                    {col.render ? col.render(r) : r[col.accessor]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
